import customAxios from '../../customAxios';
import { ADMIN_SEND_2_BANK_WITHDRAWAL_COMPANIES } from '../../routes';

const send2BankPay2Company = async (_id: string, description?: string): Promise<any> => {
  try {return (await customAxios.put(
    ADMIN_SEND_2_BANK_WITHDRAWAL_COMPANIES,
    {
      withdrawalId: _id,
      description : description,
    }
  )).data;
  } catch (error: unknown) {return console.error({ADMIN_SEND_2_BANK_WITHDRAWAL_COMPANIES: error});}
};

export default send2BankPay2Company;
